import React from 'react';
import './uiux.scss';

const UiuxLvlLife = () => {
  return (
    <div className='uiux-c-wrapper'>
      <iframe 
        title="LVL Life"
        style={{
          border: "1px solid rgba(0, 0, 0, 0.1)",
          borderRadius: "8px"
        }}
        width="800" 
        height="650" 
        src="https://embed.figma.com/design/BCkbFaIMRNWwP5O6rMVgwR/LVL-Up?embed-host=share" 
        allowfullscreen>
      </iframe>
    </div>
  )
}

const UiuxMakkiah = () => {
  return (
    <div className='uiux-c-wrapper'>
      <iframe 
        title="Makkiah.com"
        style={{
          border: "1px solid rgba(0, 0, 0, 0.1)",
          borderRadius: "8px"
        }}
        width="800" 
        height="650" 
        src="https://embed.figma.com/design/HKifuFGovoRa2SXwyBa1of/Makkiah.com?embed-host=share" 
        allowfullscreen>
      </iframe>
    </div>
  )
}

const UiuxShoeStore = () => {
  return (
    <div className='uiux-c-wrapper'>
      <iframe 
        title="Shoe Store"
        style={{
          border: "1px solid rgba(0, 0, 0, 0.1)",
          borderRadius: "8px"
        }}
        width="800" 
        height="650" 
        src="https://embed.figma.com/design/NimSmi09Zq5kwBugCumB1EYl/Shoe-Site?embed-host=share"        allowfullscreen>
      </iframe>
    </div>
  )
}

export {UiuxLvlLife, UiuxMakkiah, UiuxShoeStore};